export default "__VITE_ASSET__CesaulUj__"